import React, { type JSX } from 'react';
import {
  IPrismicImage,
  IPrismicLink,
  PrismicLinkContext,
} from '@monofront/types';
import { PrismicLink } from '../../prismic-link/PrismicLink';
import ResponsiveImage from '../ResponsiveImage';
import HyperLink from '../HyperLink';
import Button from '../Button';
import { ImageField } from '@prismicio/client/*';

interface ICtaButton {
  label: string;
  onClick: () => void;
}

interface ICtaLink {
  link: IPrismicLink;
  label: string;
  trackingId?: string | null;
  context: PrismicLinkContext;
}

interface IEditorialCard {
  title?: JSX.Element | null;
  content?: JSX.Element | null;
  illustration?: IPrismicImage | ImageField<null, 'filled'> | null;
  ctaLink?: ICtaLink | null;
  ctaButton?: ICtaButton | null;
  backgroundColor?: string | null;
}

const EditorialCard: React.FC<IEditorialCard> = ({
  title,
  content,
  illustration,
  backgroundColor,
  ctaLink,
  ctaButton,
}) => {
  return (
    <>
      <section className="editorial-card tw-max-w-[250px] max-md:tw-h-full md:tw-min-w-[250px]">
        {illustration && (
          <div className="image-wrapper">
            <ResponsiveImage
              src={illustration.url}
              alt={illustration.alt || ''}
              width={illustration.dimensions.width}
              height={illustration.dimensions.height}
            />
          </div>
        )}
        {title && <div className="card-title">{title}</div>}
        {content && <div className="card-content">{content}</div>}
        {ctaLink && (
          <PrismicLink
            link={ctaLink.link}
            context={ctaLink.context}
            trackingId={ctaLink.trackingId || undefined}
          >
            <HyperLink
              className="card-cta tw-inline-flex"
              variant="button-primary-span"
            >
              {ctaLink.label}
            </HyperLink>
          </PrismicLink>
        )}
        {ctaButton && (
          <Button onClick={ctaButton.onClick} hasMinWidth={false}>
            {ctaButton.label}
          </Button>
        )}
      </section>
      <style jsx>{`
        .editorial-card {
          display: flex;
          flex-direction: column;
          padding: var(--space-6) var(--space-5);
          border-radius: var(--rd-2);
          background: ${backgroundColor || `var(--clr-tertiary-2)`};
          text-align: center;
        }

        .image-wrapper {
          margin-bottom: var(--space-3);
        }

        .card-title {
          margin-bottom: var(--space-2);
        }

        .card-content {
          flex-grow: 1;
          margin-bottom: var(--space-4);
        }
      `}</style>
    </>
  );
};

export default EditorialCard;
